module.exports = __webpack_public_path__ + "img/demo_landscaper.4af7b6c6.jpg";